import React from "react";

import Form, { formTypes } from "../../Forms/Containers/FormCreator";
import CalendarIcon from "@material-ui/icons/CalendarToday";

import {
  INFORM_GENERATOR,
  LANDING_MENU_BAR
} from "./../../constants/strings/StringsDashboard";

function GenerateInformComponent(props) {
  return (
    <>
      <div>
        <h1 className="page-title">{LANDING_MENU_BAR.GENERATE_INFORM}</h1>
      </div>
      <div className="container-content">
        <div className="content-line">
          <div className="line line-100 text-center">
            <p>
              <span className="error-msg">*</span>{" "}
              {INFORM_GENERATOR.SELECT_KIND_INFORM}
            </p>
            <input
              type={"date"}
              id="dateRange0"
              className={"date client-date-picker"}
              onChange={props.onChangeDate}
              max={new Date().toISOString().split("T")[0]}
            ></input>
            <CalendarIcon className="primary-color" />
          </div>
          <div className="line line-100 text-center">
            <p className="error-msg">{props.state.error}</p>
          </div>
          <div className="line line-100">
            <Form
              onChange={props.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-100"
                },

                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                },
                {
                  type: formTypes.submit,
                  classContainer: "button-primary line line-10 text-center",
                  label: `Generar`,
                  placeholder: "-",
                  onClick: props.onSave
                },
                {
                  type: formTypes.buttonclick,
                  classContainer: "button-secondary line line-10 text-center",
                  label: `cancelar`,
                  placeholder: "-",
                  onClick: props.onCancel
                  // onActive: ()=>{}
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                }
              ]}
              onSubmit={props.onSave}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default GenerateInformComponent;
